import Img1 from "../assets/images/event1.jpeg";
import Img2 from "../assets/images/events2.jpg";
import Img3 from "../assets/images/events3.png";
import Img4 from "../assets/images/events5.jpeg";
import Img5 from "../assets/images/events6.jpg";
import Img6 from "../assets/images/events7.jpeg";
export const latestEvents = [
  {
    eventsHeading: "Network for Educational Advancement and Development",
    eventBanner: Img1,
    eventDate: "25 june 2023",
    view: "59",
    comment: "19",
    eventDetail:
      "Running a business is both rewarding and challenging. It comes with the immense satisfaction of blazing your own trail and building something valuable on your own terms. At AFF, we can help you achieve your goals..",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",
    tag1: "research",
    tag2: "physics",
    tag3: "education",
    tag4: "science",
    id: 1,
  },
  {
    eventsHeading: "2024 ISA Lecture Series",
    eventBanner: Img2,
    eventDate: "25 june 2023",
    view: "59",
    comment: "19",
    eventDetail:
      "Working in a family business is both rewarding and challenging. Carving your own place on your terms can be tough. Don’t worry, you’re not alone.We’ll be able to equip you with the knowledge and skills.... ",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",
    tag1: "research",
    tag2: "physics",
    tag3: "education",
    tag4: "science",
    id: 2,
  },
  {
    eventsHeading: "Individual Fellowship 2021",
    eventBanner: Img3,
    eventDate: "25 june 2023",
    view: "59",
    comment: "19",
    eventDetail:
      "We actively support family businesses on their journey to multigenerational success by understanding their needs, providing them with relevant learning and connecting them with fellow business owners and advisors. ...",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",
    tag1: "research",
    tag2: "physics",
    tag3: "education",
    tag4: "science",

    id: 3,
  },
  {
    eventsHeading: "FAMILY BUSINESS ADVISERS",
    eventBanner: Img4,
    eventDate: "25 june 2023",
    view: "59",
    comment: "19",
    eventDetail:
      "Are you a business advisor? Are you interested in advising more familybusinesses? Become an AFF Accredited Adviser and set yourself apart as a specialist in the area of family business.",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",
    tag1: "research",
    tag2: "physics",
    tag3: "education",
    tag4: "science",

    id: 4,
  },
  {
    eventsHeading: "Breakthrough ",
    eventBanner: Img5,
    eventDate: "25 june 2023",
    view: "59",
    comment: "19",
    eventDetail:
      "Are you a business advisor? Are you interested in advising more familybusinesses? Become an AFF Accredited Adviser and set yourself apart as a specialist in the area of family business.",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",
    id: 5,
  },
  {
    eventsHeading: "Meet ANd Greet ",
    eventBanner: Img6,
    eventDate: "25 june 2023",
    view: "59",
    comment: "19",
    eventDetail:
      "Are you a business advisor? Are you interested in advising more familybusinesses? Become an AFF Accredited Adviser and set yourself apart as a specialist in the area of family business.",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",
    id: 6,
  },
  // {
  //   eventsHeading: "Student Team",
  //   eventBanner: Img3,
  //   eventDate: "25 june 2023",
  //   view: "59",
  //   comment: "19",
  // eventDetail: "A team of physics students from",
  //   id: 7,
  // },
  // {
  //   eventsHeading: "Cutting-Edge ",
  //   eventBanner: Img4,
  //   eventDate: "25 june 2023",
  //   view: "59",
  //   comment: "19",
  // eventDetail:
  //     "The Physics Department has invested in state-of-the-art laboratory ",
  //   id: 8,
  // },
];
